import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { PipesModule } from '../../../pipes';
import { ReactiveFormDropdownFieldComponent } from './reactive-form-dropdown-field.component';

@NgModule({
  imports: [CommonModule, PipesModule, NzIconModule, ReactiveFormsModule, NgbTooltipModule],
  declarations: [ReactiveFormDropdownFieldComponent],
  exports: [ReactiveFormDropdownFieldComponent],
})
export class ReactiveFormDropdownFieldModule {}
